import { useEffect } from 'react';

/** Define o titulo da aba e restaura o anterior ao desmontar. */
export function useDocumentTitle(title: string, suffix = 'CRM'): void {
  useEffect(() => {
    const previous = document.title;
    document.title = suffix ? `${title} | ${suffix}` : title;

    return () => {
      document.title = previous;
    };
  }, [title, suffix]);
}
